import TextHr from './TextHr'

export default TextHr
